export default {
  methods: {
    getHierarchy (list) {
      let map = {}
      let node = {}
      let roots = []

      for (let i in list) {
        map[list[i].id] = i // initialize the map
        list[i].children = list[i].type === 1 ? [] : null // initialize the children
      }

      for (let i in list) {
        // Stores current node
        node = list[i]

        // Verifies if node has a parent
        if (node.parentId) {
          // Verifies if node parent exists
          if (list[map[node.parentId]]) {
            if (list[map[node.parentId]].children) {
              // Add this node to his parent
              list[map[node.parentId]].children.push(node)
            } else {
              list[map[node.parentId]].children = [node]
            }
          }
        } else {
          // Add a new node in roots
          roots.push(node)
        }
      }

      return roots
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/mixins/itemMixim.js